import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { customerLogin } from "../services/customerLoginService";
import { adminLogin } from "../services/adminLoginService";

function Login() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!username || !password) {
      setError("Username and password required");
      return;
    }

    try {
      setLoading(true);

      let data;

      // ✅ CHECK ADMIN LOGIN (#username)
      if (username.startsWith("#")) {
        const cleanUsername = username.substring(1); // remove #

        data = await adminLogin({
          username: cleanUsername,
          password,
        });

        // ✅ SAVE ADMIN DATA
        localStorage.setItem("token", data.access_token);
        localStorage.setItem("admin_token", data.access_token);
        localStorage.setItem("username", cleanUsername);
        localStorage.setItem("role", "admin");
        localStorage.setItem("customers", JSON.stringify(data.customers));

      } else {
        // ✅ CUSTOMER LOGIN
        data = await customerLogin({ username, password });

        localStorage.setItem("token", data.access_token);
        localStorage.setItem("username", username);
        localStorage.setItem("customer_id", data.customer_id);
        localStorage.setItem("customer_name", data.customer_name);
        localStorage.setItem("type_id", data.type_id);
        localStorage.setItem("roles", JSON.stringify(data.roles));
        localStorage.setItem("role", "customer");
      }

      navigate("/dashboard");

    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page d-flex justify-content-center align-items-center">
      <div className="login-box shadow">

        <h2 className="mb-3">Login</h2>

        <form onSubmit={handleLogin}>

          <input
            className="form-control mb-2"
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />

          <input
            className="form-control mb-2"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {error && <p className="text-danger">{error}</p>}

          <button
            className="btn btn-danger w-100"
            type="submit"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>

        </form>

      </div>
    </div>
  );
}

export default Login;